import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4f35eb94&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f35eb94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f35eb94')) {
      api.createRecord('4f35eb94', component.options)
    } else {
      api.reload('4f35eb94', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=4f35eb94&scoped=true&", function () {
      api.rerender('4f35eb94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket/Edit.vue"
export default component.exports